<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<h2 class="fmh" id="ch2"><a href="#/9781789742671_EPUB5#ch2">AUTHOR’S PREFACE</a></h2>
<p class="tx">During my college experience with InterVarsity Christian Fellowship, I was given the Tyndale commentary written by Ralph Martin as I prepared to lead a small-group Bible study on Philippians. This was the very first commentary I owned, and I fell in love with Paul’s letter to the Philippians during that year of Bible study. I am grateful for the opportunity in God’s providence to write this second edition on Philippians in the Tyndale series.</p>
<p class="txt">I want to thank a group of students who read the drafts of the commentary in a course on Philippians in spring 2021. Their joy in studying the text and willingness to engage with my ideas as they were fresh off the page spurred me on and sharpened my work. I am also grateful to my teaching assistants, Jenelle Lemons and Narah Larson, for their careful editing and thoughtful input. My editor, Eckhard Schnabel, provided invaluable feedback; and the team at Inter-Varsity Press was wonderful to work with from beginning to end.</p>
<p class="txt">Paul’s letter to the Philippians continues to speak to the global church today. It offers guidance to contemporary churches seeking, in their specific cultural and societal contexts, to live out their distinctive identity in the Messiah and to pattern their lives together on the example of Jesus. Additionally, I would suggest that Paul’s way of addressing this beloved congregation is a model of Christian leadership for those called to shepherd God’s people today. It is with this pastoral vision in mind that I dedicate this book to my students at Bethel Seminary – both past and present. May your relationship with those you lead be the kind that Paul celebrates in this letter: ‘my brothers and sisters, you whom I love and long for, my joy and crown, stand firm in the Lord in this way, dear friends!’ (Phil. 4:1).</p>
<p class="rtx-t">Jeannine Brown</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781789742671_EPUB7.vue?e7a4e8ce